import { useMemo, useState } from 'react';
import { Box, Text, Flex, Image } from '@chakra-ui/react';

import notifyError from 'assets/svg/notify-error.svg';
import { textLang } from 'services/Lang';

import Card from 'components/Card/Card';

export default function Errors (props) {
  return (
    <>
    	<Card 
          borderRadius="16px"
          maxW={props.maxW ?? '100%'}
          mt={props.mt ?? 'unset'}
          variant="ghost" 
          padding='16px'
          border="1px solid #ED2014"
          mb={{ sm: '8px' }}>
          <Flex alignItems="center" gap="10px">
            <Image src={notifyError} h="24px"/>
            <Text maxW={{sm: '100%', md: '70%'}} variant="text-sm">
			  {typeof props.error === 'string' ? `${textLang('error')}: ${props.error}` : textLang('error_other')}
            </Text>
          </Flex>
        </Card>
    </>
  );
}